import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { useQueryClient } from '@tanstack/react-query';

/**
 * Refetch active React Query data for the current workspace.
 * Also dispatches `app:page-refresh` for pages that load outside React Query.
 */
const PageRefreshButton = ({ className = '', label = 'Refresh' }) => {
  const queryClient = useQueryClient();
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = async () => {
    if (refreshing) return;
    setRefreshing(true);
    try {
      await queryClient.invalidateQueries();
      await queryClient.refetchQueries({ type: 'active' });
      window.dispatchEvent(new CustomEvent('app:page-refresh'));
    } finally {
      // Brief spin so the control always feels responsive
      window.setTimeout(() => setRefreshing(false), 400);
    }
  };

  return (
    <button
      type="button"
      onClick={handleRefresh}
      disabled={refreshing}
      className={`inline-flex h-8 items-center gap-1.5 rounded-md border border-border bg-surface px-2 text-ink-secondary transition-colors hover:bg-surface-muted hover:text-ink disabled:opacity-60 sm:px-2.5 ${className}`}
      title="Refresh page data"
      aria-label="Refresh page data"
    >
      <RefreshCw className={`h-3.5 w-3.5 ${refreshing ? 'animate-spin' : ''}`} />
      <span className="hidden text-xs font-medium sm:inline">{label}</span>
    </button>
  );
};

export default PageRefreshButton;
